import { type KeyboardEvent } from 'react';
import { Center, Table, Text } from '@mantine/core';
import { getCurrencyIcon } from '~/entities/currency';
import { OrderIdLink } from '~/entities/order';
import { formatOrder, type PayoutOrder } from '~/entities/payout';
import { CopyIcon } from '~/shared/ui/CopyIcon';
import { createOrderCountdown, createOrderStatusBadge } from '../../../../../../../OrderManagement';
import { getOrderCopyText } from '../../lib';
import { Requisite } from './components';
import styles from './OrderRow.module.css';

interface OrderRowProps {
    order: PayoutOrder;
    onClick: (order: PayoutOrder) => void;
}

export const OrderRow = ({ order, onClick }: OrderRowProps) => {
    const orderId = order.id?.value;

    const handleKeyboardOpen = (event: KeyboardEvent<HTMLTableRowElement>) => {
        if (event.currentTarget !== event.target || (event.key !== 'Enter' && event.key !== ' ')) {
            return;
        }

        event.preventDefault();
        onClick(order);
    };

    return (
        <Table.Tr
            className={styles.row}
            tabIndex={0}
            aria-label={orderId ? `Открыть ордер ${orderId}` : 'Открыть ордер'}
            onClick={() => onClick(order)}
            onKeyDown={handleKeyboardOpen}
        >
            <Table.Td>
                <Center>
                    <OrderIdLink
                        direction='payout'
                        orderId={orderId}
                    />
                </Center>
            </Table.Td>
            <Table.Td>
                <Text ta='center'>{formatOrder.date(order.createdAt)}</Text>
            </Table.Td>
            <Table.Td>
                <Text ta='center'>{order.traderName?.value}</Text>
            </Table.Td>
            <Table.Td>
                <Requisite requisiteV2={order.requisiteV2} />
            </Table.Td>
            <Table.Td>
                <Text ta='center'>{order.amount?.value}</Text>
            </Table.Td>
            <Table.Td>
                <Text ta='center'>{getCurrencyIcon(order.currency)}</Text>
            </Table.Td>
            <Table.Td>
                <Text ta='center'>{order.rate?.value ?? '-'}</Text>
            </Table.Td>
            <Table.Td>{order.publicStatus ? createOrderStatusBadge(order.publicStatus, true) : '-'}</Table.Td>
            <Table.Td>
                <Center>{createOrderCountdown(order.expiresAt)}</Center>
            </Table.Td>
            <Table.Td>
                <Center>
                    <CopyIcon
                        stopPropagation
                        value={getOrderCopyText(order, formatOrder)}
                    />
                </Center>
            </Table.Td>
        </Table.Tr>
    );
};
